import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Select, Spin } from "antd";
import dayjs from "dayjs";
import Table from "../../../core/pagination/Newdatatable";
import { getApiBaseUrl } from "../Config/Config";
const { Option } = Select;

const ReplacementList = () => {
  const searchInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [replacementList, setReplacementList] = useState([]);
  const [replacementLoading, setReplacementLoading] = useState(true);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [blocks, setBlocks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const userType = JSON.parse(sessionStorage.getItem("UserType"));

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const result = await response.json();
        if (result?.ResultData && result?.ResultData?.length > 0) {
          setBlocks(result?.ResultData);
          // setSelectedBlock(result?.ResultData[0].BlockId);
        }
      } catch (err) {
        console.error("Error fetching blocks:", err);
      }
    };
    fetchBlocks();
  }, []);

  const handleBlockChange = (blockId) => {
    setSelectedBlock(blockId);
  };

  const fetchReplacementList = async (page = 1, limit = 100, search = "") => {
    setReplacementLoading(true);

    try {
      const baseParams = `blockid=${selectedBlock}&ProcessType=${userType}&pageNumber=${page}&recordslimit=${limit}`;
      const searchParam = search.trim()
        ? `&Search=${encodeURIComponent(search.trim())}`
        : "&Search=";
      const response = await fetch(
        `http://192.168.1.100:8080/filterph2/getReplaceListph2?${baseParams}${searchParam}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const list = result?.ResultData || [];
      setReplacementList(list || []);
      if (list?.length > 0) {
        setTotalRecords(list[0]?.TotalCount || 0);
      }
    } catch (err) {
      console.log(err.message || "Something went wrong");
      setTotalRecords(0);
      setReplacementList([]);
    } finally {
      setReplacementLoading(false);
    }
  };

  useEffect(() => {
    console.log("cvvvvvvvvvvvvvvvvvvvvvvv");

    const handleFilterChange = () => {
      console.log("pppppppppppppppppppppppppppppppppppp");
      fetchReplacementList();
    };

    window.addEventListener("filtertypechange", handleFilterChange);

    return () => {
      window.removeEventListener("filtertypechange", handleFilterChange);
    };
  }, []);

  const handleSearch = () => {
    const value = searchInputRef.current?.value?.trim() || "";
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // Call fetchReplacementList on component mount
  useEffect(() => {
    fetchReplacementList(currentPage, pageSize, searchTerm);
  }, [selectedBlock, currentPage, pageSize, userType, searchTerm]);

  const columns = [
    {
      title: "Old Filter ID",
      dataIndex: "OldLable",
      key: "OldLable",
      sorter: (a, b) => a?.OldLable?.length - b?.OldLable?.length,
    },
    {
      title: "New Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      // sorter: (a, b) => a.AHUcode - b.AHUcode,
    },

    // {
    //   title: "Location",
    //   dataIndex: "locatinname",
    //   key: "locatinname",
    //   sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    // },
    {
      title: " User ID",
      dataIndex: "UserName",
      key: "UserName",
      sorter: (a, b) => a.UserName.localeCompare(b.UserName),
    },
    // {
    //   title: "Status",
    //   dataIndex: "StageName",
    //   key: "StageName",
    //   render: (text) => <span className="badge bg-danger">{text}</span>,
    // },
    // {
    //   title: "Last Change",
    //   dataIndex: "LastCleaningDate",
    //   key: "LastCleaningDate",
    //   sorter: (a, b) =>
    //     new Date(a.LastCleaningDate) - new Date(b.LastCleaningDate),
    //   render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    // },
    {
      title: "Replaced Date",
      dataIndex: "ReplacedOn",
      key: "ReplacedOn",
      sorter: (a, b) => new Date(a.ReplacedOn) - new Date(b.ReplacedOn),
      render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    },

    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Replacement List
                  </h4>
                </ol>
              </nav>
              <h6>Find replaced filters below </h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li></li>
          </ul>
        </div>

        <div className="card table-list-card no-search">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set m-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search filters..."
                  ref={searchInputRef}
                  onKeyPress={handleKeyPress}
                  defaultValue={searchTerm}
                />
                <button
                  className="btn btn-primary btn-sm"
                  onClick={handleSearch}
                  disabled={replacementLoading}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedBlock === 0 ? 0 : selectedBlock} // Ensures "All" is shown when value is 0
                  onChange={handleBlockChange}
                  placeholder="Select Block"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {replacementLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : replacementList.length > 0 ? (
                <Table
                  columns={columns}
                  dataSource={replacementList}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  totalRecords={totalRecords}
                  onPageChange={(page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  }}
                />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplacementList;
